import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import onKey from 'ember-keyboard/modifiers/on-key';

import Button from 'umg-ember-backend/components/ui/button';
import { Codemirror } from 'umg-ember-backend/components/ui/codemirror';
import Form from 'umg-ember-backend/components/ui/form';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../styles.module.css';

const bem = getBem(styles);

class ExternalMediaEmbedSettings {
  id = 0;
  recordType = 'external-media-embed';
  @tracked type = 'youtube';
  @tracked embedId = '';
}

export default class ApplicationConfirmExternalMediaEmbed extends Component {
  // Defaults
  externalMediaEmbedSettings = new ExternalMediaEmbedSettings();

  // Getter and setter
  get externalMedia() {
    return {
      externalMediaId: this.externalMediaEmbedSettings.embedId,
      externalMediaType: this.externalMediaEmbedSettings.type,
    };
  }

  get externalMediaInfo() {
    let embedId = this.externalMediaEmbedSettings.embedId || '<EMBED_ID>';

    let responses = {
      youtube: `<iframe ... src='https://www.youtube.com/embed/${embedId}' ...></iframe>`,
      vevo: `<iframe ... src='https://embed.vevo.com?isrc=${embedId}' ...></iframe>`,
      soundcloud: `<iframe ... src='https://w.soundcloud.com/player/?url=https://api.soundcloud.com/tracks/${embedId}' ...></iframe>`,
      vimeo: `<iframe ... src='https://player.vimeo.com/video/${embedId}' ...></iframe>`,
      iframe: `<iframe ... src='${embedId}' ...></iframe>`,
    };

    return responses[this.externalMediaEmbedSettings.type];
  }

  get typeOptions() {
    return [
      {
        value: 'youtube',
        label: 'YouTube',
      },
      {
        value: 'vevo',
        label: 'Vevo',
      },
      {
        value: 'myvideo',
        label: 'MyVideo',
      },
      {
        value: 'soundcloud',
        label: 'SoundCloud',
      },
      {
        value: 'vimeo',
        label: 'Vimeo',
      },
      {
        value: 'facebook',
        label: 'Facebook',
      },
      {
        value: 'twitter',
        label: 'Twitter',
      },
      {
        value: 'instagram',
        label: 'Instagram',
      },
      {
        value: 'iframe',
        label: 'iFrame',
      },
    ];
  }

  // Functions
  changeExternalMediaType = (value) => {
    this.externalMediaEmbedSettings.type = value.target.value;
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <h2 class={{bem 'title'}}>
        {{t @confirm.title}}
      </h2>

      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{this.externalMediaEmbedSettings}}
        as |form|
      >
        <form.field
          @property='type'
          @renderInPlace={{true}}
          @type='select-value'
          @options={{this.typeOptions}}
        />
        <form.field @property='embedId' />

        {{#if this.externalMediaInfo}}
          <label>{{t 'confirm.tinymce_external_media.findEmbedId'}}</label>

          <Codemirror
            @value={{this.externalMediaInfo}}
            @readOnly={{true}}
            @mode='html'
          />
        {{/if}}

        <Button
          @label={{t 'application.confirm.default.confirm'}}
          {{on 'click' (fn @confirm.confirm this.externalMedia)}}
          {{onKey 'Enter' (fn @confirm.confirm this.externalMedia)}}
        />

        <Button
          @label={{t 'application.confirm.default.cancel'}}
          @style='grey'
          {{on 'click' @confirm.cancel}}
          {{onKey 'Escape' @confirm.cancel}}
        />
      </Form>
    </div>
  </template>
}
